// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { BenefitLifecycleOperationsService } from '../generated/api/benefitLifecycleOperations.service';

@Injectable({ providedIn: 'root' })
export class BenefitLifecycleOperationsClientService {
  constructor(private readonly client: BenefitLifecycleOperationsService) {}
  // <generated-client-wrappers:methods>
  get(
    page?: number,
    pageSize?: number,
    consumerAppId?: string,
    transactionId?: string,
    state?: 1 | 2 | 3,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitLifecyclePage> {
    if (!this.client)
      throw new Error('BenefitLifecycleOperationsService is not available');
    return this.client.benefitLifecycleOperationsGet(
      page,
      pageSize,
      consumerAppId,
      transactionId,
      state,
      'body',
      reportProgress,
      options,
    );
  }

  getRetries(
    transactionId: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitLifecycleRetryPage> {
    if (!this.client)
      throw new Error('BenefitLifecycleOperationsService is not available');
    return this.client.benefitLifecycleOperationsGetRetries(
      transactionId,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  retry(
    transactionId: string,
    request: WrapperApi.BenefitLifecycleRetryRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.BenefitLifecycleRetryResponse> {
    if (!this.client)
      throw new Error('BenefitLifecycleOperationsService is not available');
    return this.client.benefitLifecycleOperationsRetry(
      transactionId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
